"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAmountInCents = exports.amountToString = void 0;
var formatAmountInCents = function formatAmountInCents(amountInCents) {
  var value = amountInCents / 100;
  return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.formatAmountInCents = formatAmountInCents;
var amountToString = function amountToString(value) {
  return value.amount === undefined ? '' : value.amount.toFixed(2);
};
exports.amountToString = amountToString;